import React, {FC} from 'react';
import {Template} from "./jackpotHelper";

const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;
const defaultsStyles = {
    blockBgGradient: 'linear-gradient(to right, #eb5757, #000000',
}
interface JL {
    styles: Template,
    operator:string
}
const JackpotLoader: FC <JL> = ({styles, operator}) => {
    return (
        <div className="App">
            <header className="App-header" style={{
                backgroundColor: styles.colors.mainBgColor,
            }}>
                <div className="operator-logo" >
                    <img
                        src={toAbsoluteUrl(`/assets/img/spinner_${operator}.webp`)}
                        onError={(e) => { e.currentTarget.src = toAbsoluteUrl('/assets/img/betstack_logo_small.webp'); }}
                        alt="operator-logo"
                    />
                </div>
                <p>
                    Loading...
                </p>
            </header>
        </div>
    );

}

export default JackpotLoader;
